<template>
	<div class="environment-card">
		<div class="environment-card__body">
			<template>
				<slot name="checkbox" />
			</template>

			<div class="environment-card__main">
				<label
					:for="modelValue.id"
					data-test="environmentCardLabel"
					v-if="modelValue.dealershipGroup"
				>
					<Ellipsis
						:data="modelValue.dealershipGroup"
						class="environment-card__title"
					></Ellipsis>
				</label>
				<div
					class="environment-card__group-number"
					v-if="modelValue.dealershipGroupNumber"
				>
					#{{ modelValue.dealershipGroupNumber }}
				</div>
				<TagLabel
					class="environment-card__tag"
					:message="'Scheduled'"
					v-if="modelValue.scheduled"
				/>
			</div>

			<ActionsSet
				class="environment-card__actions"
				:id="`${uid}_action`"
				:variant="variant"
				:options="loadActions"
			/>
		</div>
		<ZoneIndicator
			v-if="
				modelValue.environmentName &&
					showZoneIndicator(modelValue.environmentId)
			"
			:message="modelValue.environmentName"
			:state="zoneColors(modelValue.environmentId)"
			:hasZonePermission="false"
		/>
	</div>
</template>

<script>
import ActionsSet from '@/site-components/actions-set/actions-set';
import Ellipsis from '@/components/visual/ellipsis';
import TagLabel from '@/components/visual/tag-label';
import ZoneIndicator from '@/components/visual/zone-indicator';

//mixins
import ZoneColors from '@/mixins/zoneColors';
import { MODULE_NAME } from '@/sections/options/options-mutation-type.js';

//vuex
import { mapGetters } from 'vuex';

export default {
	name: 'EnvironmentSummaryCard',
	model: {
		prop: 'modelValue'
	},
	components: {
		ActionsSet,
		Ellipsis,
		TagLabel,
		ZoneIndicator
	},
	mixins: [ZoneColors],
	props: {
		modelValue: {
			type: Object,
			default: () => {}
		}
	},
	computed: {
		...mapGetters(MODULE_NAME, ['showZoneIndicator']),

		loadActions() {
			return [
				{
					id: 1,
					action: {
						path: `/environments/${this.modelValue.id}/history`
					},
					disabled: false,
					title: 'Select to go to history',
					iconClass: 'icon icon-history',
					label: 'History',
					type: 'route-link',
					visible: true
				},
				{
					id: 2,
					action: this.showCCLsModal,
					disabled: false,
					title: 'Select to go to CCLs',
					iconClass: 'icon icon-document',
					label: 'CCLs',
					type: 'anchor',
					valueBadgeCount: this.countCompaniesAndLocations,
					visible: this.countCompaniesAndLocations
				}
			];
		},
		countCompanies() {
			let total = 0;
			if (this.modelValue?.companies?.length > 0) {
				total = this.modelValue?.companies?.length;
			}
			return total;
		},
		countLocations() {
			const initialValue = 0;
			let total = 0;
			if (this.modelValue?.companies?.length > 0) {
				total = this.modelValue?.companies?.reduce(
					(sum, company) => sum + company.locations?.length,
					initialValue
				);
			}
			return total;
		},
		countCompaniesAndLocations() {
			return this.countCompanies + this.countLocations;
		}
	},
	methods: {
		showCCLsModal() {
			this.$emit('showCustomerCompanyLocations');
		}
	}
};
</script>

<style lang="scss" scoped>
/**
    * Environment Card
 */

@import '@/scss/5-objects/_cards.scss';

.environment-card {
	@include card('indicator');
	display: flex;
	flex-direction: column;
	min-height: 88px;
	justify-content: space-between;
	gap: $gutter-lg;
	@include body-text('regular');

	&__body {
		display: grid;
		grid-template-columns: auto 1fr auto;
		gap: $gutter-md;

		> * {
			&:first-child {
				align-self: start;
				margin-top: $gutter-xs;
			}
		}
	}

	&__main {
		min-width: 0;
	}

	&__title {
		cursor: default;
		@include heading('md');
		text-transform: capitalize;
		margin-bottom: $gutter-md;
	}

	&__tag {
		margin-top: $gutter-md;
	}
}
</style>
